import { render } from "./freightTransport.vue?vue&type=template&id=dc4f3680&scoped=true"
import script from "./freightTransport.vue?vue&type=script&lang=js"
export * from "./freightTransport.vue?vue&type=script&lang=js"

import "./freightTransport.vue?vue&type=style&index=0&id=dc4f3680&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc4f3680"]])

export default __exports__